export default __webpack_public_path__ + "static/media/barnconversion.41950cbd.jpg";